import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@/ui/Button';
import { ROUTE_PATH } from '@/constants/routePaths';

const HeaderStyled = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.outline1};
  background: ${({ theme }) => theme.colors.neutral.background};
`;

type JourneyCertificateHeaderProps = {
  journeyId: number;
  journeyName?: string;
  certificateUrl?: string;
};

export const JourneyCertificateHeader = ({
  journeyId,
  journeyName,
  certificateUrl,
}: JourneyCertificateHeaderProps): JSX.Element => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (!journeyId || !journeyName) {
      navigate(ROUTE_PATH.MY_LEARNING);
      return;
    }

    navigate(`${ROUTE_PATH.JOURNEY_BASE}/${journeyId}/${journeyName}`);
  };

  const handleDownload = () => {
    if (!certificateUrl) {
      return;
    }

    // The certificate is served from a different origin (storage/CDN), so we open the presigned URL
    // instead of fetching it — a programmatic fetch would be blocked by CORS.
    window.open(certificateUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <HeaderStyled>
      <Button variant="ghost" icon="long-arrow-alt-left" onClick={handleBack}>
        Back to journey
      </Button>
      <Button variant="primary" onClick={handleDownload} disabled={!certificateUrl}>
        Download PDF
      </Button>
    </HeaderStyled>
  );
};
